import type { ReactElement } from 'react';

import './Details.scss';
import { useGallery } from '../../../../provider/GalleryProvider';
import { Button } from '@fastnorth/react-cerberus/Button';
import { useNavigate, useParams } from 'react-router-dom';
import type { AppUrlParams } from '../../../../types';
import { SocialShare, useEvent } from '@fastnorth/react-results-event-components';
import ReportDialog from '../report-dialog/ReportDialog';
import { useTranslation } from 'react-i18next';

type DetailsType = {
  tags?: string[];
};

const Details = ({ tags }: DetailsType): ReactElement => {
  const { gallery } = useGallery();
  const navigate = useNavigate();
  const { locale, groupId, photoId } = useParams<AppUrlParams>() as AppUrlParams;
  const { event } = useEvent();
  const { t } = useTranslation();
  const group = gallery?.groups.find((g) => g.id === groupId);
  const logo = event?.branding?.logo;
  const shareUrl = window.location.href;

  return (
    <footer className={'carousel__details-container'}>
      {logo && <img className={'carousel__event-logo d-none d-md-inline-block'} src={logo} alt={event?.name} />}
      <div className={'carousel__details'}>
        {event && (
          <h2 className={'h1 mb-0'}>
            {logo && (
              <img className={'carousel__event-logo-mobile d-sm-inline-block d-md-none'} src={logo} alt={event?.name} />
            )}
            {event?.name}
          </h2>
        )}
        <p className={'h4'}>{group?.name}</p>
        {tags && tags.length > 0 && (
          <div className={'carousel__tags mb-3 mb-md-0'}>
            <p>{t('photos_ui.photo_modal.tags')}</p>
            <ul>
              {tags.map((tag) => (
                <li key={tag}>
                  <Button
                    className={'mr-2 custom-secondary-color custom-secondary-border-color custom-primary-text-color'}
                    text={tag}
                    variant={'secondary'}
                    size={'sm'}
                    onClick={() =>
                      navigate({
                        pathname: `/${locale}/galleries/${gallery?.id}/search`,
                        search: `?tags=${tag}`,
                      })
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className={'carousel__actions'}>
        {gallery && photoId && (
          <>
            <ReportDialog photoId={photoId} galleryId={gallery?.id} />
            <SocialShare
              shareLabel={`${t('photos_ui.share')}`}
              smallSize={true}
              facebookUrl={shareUrl}
              twitterUrl={shareUrl}
              useEventBranding={true}
            />
          </>
        )}
      </div>
    </footer>
  );
};

export default Details;
